if (!customElements.get('esc-carousel')) {
  class EscCarousel extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[id^="Slider-"]');
      this.slides = Array.from(this.querySelectorAll('[id^="Slide-"]'));
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.dots = Array.from(this.querySelectorAll('.slider-counter__link'));
      if (!this.slider || this.slides.length < 2) return;

      this.index = 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.goTo(this.index - 1, true));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.goTo(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', (e) => {
        e.preventDefault();
        this.goTo(i, true);
      }));

      this.slider.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.syncToScroll(), 120);
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());

      this.onVisibility = () => (document.hidden ? this.pause() : this.resume());
      document.addEventListener('visibilitychange', this.onVisibility);

      // theme editor: hold the slide an admin selects, resume on deselect
      this.onBlockSelect = (event) => {
        const i = this.slides.indexOf(event.target);
        if (i >= 0) {
          this.pause();
          this.goTo(i, false);
        }
      };
      this.onBlockDeselect = (event) => {
        if (this.slides.includes(event.target)) this.resume();
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.updateControls();
      this.resume();
    }

    disconnectedCallback() {
      this.pause();
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    slideDuration(i) {
      const seconds = parseInt(this.slides[i].dataset.duration, 10);
      return (seconds > 0 ? seconds : 6) * 1000;
    }

    syncToScroll() {
      const pos = this.slider.scrollLeft;
      let closest = 0;
      let min = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.offsetLeft - pos);
        if (d < min) {
          min = d;
          closest = i;
        }
      });
      if (closest !== this.index) {
        this.index = closest;
        this.updateControls();
        this.restartTimer();
      }
    }

    goTo(i, userInitiated) {
      const len = this.slides.length;
      this.index = ((i % len) + len) % len;
      this.slider.scrollTo({
        left: this.slides[this.index].offsetLeft,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
      });
      this.updateControls();
      if (userInitiated) this.restartTimer();
    }

    updateControls() {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('slider-counter__link--active', i === this.index);
        if (i === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    restartTimer() {
      clearTimeout(this.timer);
      if (this.paused || !this.autoplayEnabled || this.reducedMotion.matches) return;
      this.timer = setTimeout(() => {
        this.goTo(this.index + 1, false);
        this.restartTimer();
      }, this.slideDuration(this.index));
    }

    pause() {
      this.paused = true;
      clearTimeout(this.timer);
    }

    resume() {
      this.paused = false;
      this.restartTimer();
    }
  }

  customElements.define('esc-carousel', EscCarousel);
}
